import { Plugin } from 'vue';
import { initYandexMetrika } from 'yandex-metrika-vue3';

const yandexMetrika: Plugin = {
    install(app, options) {
        app.use(initYandexMetrika, options);
    },
};

export default yandexMetrika;
